
import React, { useState, useEffect } from 'react';
// eslint-disable-next-line 
import { useParams, Link, Route, Routes, useLocation } from 'react-router-dom'
import axios from "axios";



import { firebase } from "../Firebase/config";
// eslint-disable-next-line 
import { doc, getDoc, updateDoc, arrayUnion, } from "@firebase/firestore";
import NavBar from "./Navbar"

import './Messages.css';


function App(hello, studentidd) { // eslint-disable-line no-unused-vars

  // eslint-disable-next-line 
  const { only2studentid, studentid, classid, language, id, role } = useParams();

  const location = useLocation();
  const isMessagesPage = location.pathname.includes("Messages");

  //with teacher access

  //   http://localhost:3000/view/id/VO9zbrZ6czMhZTqwGkfBBEjH2CD2/only2studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

  //   http://localhost:3000/view/id/VO9zbrZ6czMhZTqwGkfBBEjH2CD2/studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

  //without teacher access

  //   http://localhost:3000/studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en 

  //   http://localhost:3000/only2studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en 



  const [studentidlocal, setstudentidlocal] = useState();



  const [parentemail, setParentemail] = useState();
  const [parentemailbefore, setParentemailbefore] = useState();
  // eslint-disable-next-line 
  const [newnumber2, setNewnumber2] = useState("");

  const [newnumber3, setNewnumber3] = useState();

  const [parentphonenumber, setParentphonenumber] = useState();
  const [parentphonenumberbefore, setParentphonenumberbefore] = useState();
  // eslint-disable-next-line 
  const [newnumber, setNewnumber] = useState("");

  const [teacher, setTeacher] = useState();
  const [classs, setClasss] = useState();
  const [student, setStudent] = useState();
  const [viewparentpage, setViewparentpage] = useState(true);

  const [text0, setText0] = useState("");
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text3, setText3] = useState("");
  const [text4, setText4] = useState("");
  const [text5, setText5] = useState("");
  const [text6, setText6] = useState("");
  const [text7, setText7] = useState("");
  const [text8, setText8] = useState("");
  const [text9, setText9] = useState("");
  const [text10, setText10] = useState("");


  const [bringinmenu2, setBringinmenu2] = useState(false);


  // Donotshow is used to show the toggle icon that is only worth showing to teachers on the About page. So it is true everywhere but on about page. 
  const [donotshow, setDonotshow] = useState();
  console.log(language, "THI SIS IS THE LANGUSAST")

  useEffect(() => {
    if (
      typeof language != "undefined" && language != "en"
    ) {
      getnewlanguaage0();
      getnewlanguaage1();
      getnewlanguaage2();
      getnewlanguaage3();
      getnewlanguaage4();
      getnewlanguaage5();
      getnewlanguaage6();
      getnewlanguaage7();
      getnewlanguaage8();
      getnewlanguaage9();
      getnewlanguaage10();
    }
  }, [language]);

  useEffect(() => {
    if (
      typeof language != "undefined" && language != "en"
    ) {
      getnewlanguaage0();
      getnewlanguaage1();
      getnewlanguaage2();
      getnewlanguaage3();
      getnewlanguaage4();
      getnewlanguaage5();
      getnewlanguaage6();
      getnewlanguaage7();
      getnewlanguaage8();
      getnewlanguaage9();
      getnewlanguaage10();
    }
  }, []);

  useEffect(() => {
    if (
      typeof language != "undefined" && language != "en"
    ) {
      getnewlanguaage0();
      getnewlanguaage1();
      getnewlanguaage2();
      getnewlanguaage3();
      getnewlanguaage4();
      getnewlanguaage5();
      getnewlanguaage6();
      getnewlanguaage7();
      getnewlanguaage8();
      getnewlanguaage9();
      getnewlanguaage10();
    }
  }, [language]);


  useEffect(() => {

    setDonotshow(true);

  }, []);


  const getnewlanguaage0 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Messaging From",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText0(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }

  };

  const getnewlanguaage1 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Class",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText1(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }

  };

  const getnewlanguaage2 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "The emails and phone numbers that",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText2(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }

  };

  const getnewlanguaage3 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "has to message you are listed below. Please leave only the numbers or email addresses if it is there where you would like to receive messages.",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText3(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage4 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Please delete the rest by pressing",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText4(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage5 = async () => {
    console.log(language, "2 the languge code");
    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Add any additional phone number or email address if it is there where you would also like to receive messages.",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText5(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }

  };

  const getnewlanguaage6 = async () => {
    console.log(language, "2 the languge code");
    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Submit this Phone Number",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText6(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage7 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Submit this new Email",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText7(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage8 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "New Email/Phone #",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText8(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage9 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Unsubscribed from Texts",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText9(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage10 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Unsubscribed from Emails",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText10(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };




  useEffect(() => {
    if (typeof only2studentid != "undefined") {
      let teach = localStorage.getItem("nameofteacher");
      let clas = localStorage.getItem("nameofclass");
      let stud = localStorage.getItem("nameofstudent");

      setTeacher(teach);
      setClasss(clas);
      setStudent(stud);
    }

    if (typeof studentid != "undefined") {
      let teach = localStorage.getItem("nameofteacher");
      let clas = localStorage.getItem("nameofclass");
      let stud = localStorage.getItem("nameofstudent");

      setTeacher(teach);
      setClasss(clas);
      setStudent(stud);
    }
  }, [only2studentid, studentid]);



  useEffect(() => {
    if (typeof only2studentid != "undefined") {
      setstudentidlocal(only2studentid)
    }
  }, [only2studentid]);

  useEffect(() => {
    if (typeof studentid != "undefined") {
      setstudentidlocal(studentid)
    }
  }, [studentid]);
  useEffect(() => {
    if (typeof studentidlocal != "undefined" && studentidlocal.length > 10) {
      seeifpersonexists();
    }
  }, [studentidlocal]);

  async function seeifpersonexists() {
    const docRef = doc(firebase, "users", studentidlocal);

    const docData = await getDoc(docRef)

      .then(async (userRec) => {

        let object = userRec.data();
        setParentemail(object.parentemail);
        setParentphonenumber(object.parentphonenumber);

        console.log(object, "it found this guy?")
      }).catch((error) => {
        // Handle any errors that occur

      }).then(async () => {

        console.log("ending rightnow")
      })
  }

  useEffect(() => {
    if (typeof studentidlocal != "undefined" && typeof parentphonenumber != "undefined") {
      console.log("in the final area")
      updatephonenumbberindatabase();
    }
  }, [parentphonenumber]);

  useEffect(() => {
    if (typeof studentidlocal != "undefined" && typeof parentemail != "undefined") {
      console.log("in the final area")
      updateemailindatabase();
    }
  }, [parentemail]);

  const onChanged1 = (text) => {
    setNewnumber3(text);
  }

  useEffect(() => {
    if (typeof parentphonenumberbefore != "undefined") {
      console.log(parentphonenumberbefore, "y999");

      // let array = parentphonenumber;
      // array.push(parentphonenumberbefore)


      updateDoc(doc(firebase, "users", studentidlocal), {
        parentphonenumber: parentphonenumberbefore
      }).catch((error) => {
        console.log(error); alert(error);
      })
    }
  }, [parentphonenumberbefore]);

  useEffect(() => {
    if (typeof parentemailbefore != "undefined") {
      console.log(parentemailbefore, "y999");

      // let array = parentphonenumber;
      // array.push(parentphonenumberbefore)


      updateDoc(doc(firebase, "users", studentidlocal), {
        parentemail: parentemailbefore
      }).catch((error) => {
        console.log(error); alert(error);
      })
    }
  }, [parentemailbefore]);


  async function addthisnumber() {

    console.log("add a new nummber was runnd", parentphonenumber);

    let currenntarray = parentphonenumber;

    currenntarray.push(newnumber3);
    setParentphonenumber(currenntarray);
    setParentphonenumberbefore(currenntarray);
    setNewnumber3("");
  }

  async function addthisnumber2() {

    console.log("add a new nummber was runnd", parentemail);

    let currenntarray2 = parentemail;

    currenntarray2.push(newnumber3);

    setParentemail(currenntarray2);
    setParentemailbefore(currenntarray2);
    setNewnumber3("");
  }


  async function updatephonenumbberindatabase() {

    console.log("did it get  in to update?", parentphonenumber)

    await updateDoc(doc(firebase, "users", studentidlocal), {
      parentphonenumber: parentphonenumber
    }).catch((error) => {
      console.log(error); alert(error);
    })
      .then(async (userRec) => {
        console.log("DOnneee")
        setParentphonenumberbefore();
      })

  }

  async function updateemailindatabase() {

    console.log("did it get  in to update?", parentemail)

    await updateDoc(doc(firebase, "users", studentidlocal), {
      parentemail: parentemail
    }).catch((error) => {
      console.log(error); alert(error);
    })
      .then(async (userRec) => {
        console.log("DOnneee")
        setParentemailbefore();
      })

  }

  async function deletethisnumber(value) {
    let temparray = [];
    parentphonenumber.forEach(element => {
      if (element !== value) {
        temparray.push(element);
      }
    });
    setParentphonenumber(temparray);

  }

  async function deletethisemail(value) {
    let temparray = [];
    parentemail.forEach(element => {
      if (element !== value) {
        temparray.push(element);
      }
    });
    setParentemail(temparray);

  }

  async function readonly() {
    alert("This page is 'Read Only' for Teachers.")

  }

  return (
    <div className="App22">
      <NavBar
        viewparentpage={isMessagesPage ? viewparentpage : null}
        setViewparentpage={isMessagesPage ? setViewparentpage : null}
        donotshow={isMessagesPage ? donotshow : null}
        bringinmenu2={isMessagesPage ? bringinmenu2 : null}
        role={isMessagesPage ? role : null}
        setBringinmenu2={isMessagesPage ? setBringinmenu2 : null}
      />

      <div className="App29">

        {id && typeof language == "undefined" ? <header className="App-header">
          <div className="container22a">


            <div className="section591">

              <p className="section5922ab" onClick={() => setBringinmenu2(!bringinmenu2)} ofclassavailable>Messaging From <br />{student}'s {classs} Class</p>

              <br />   <br />

              <p className="section5922ax" onClick={() => setBringinmenu2(!bringinmenu2)}>The emails and phone numbers that {teacher} has to message you are listed below. Please leave only the numbers or email addresses if it is there where you would like to receive messages.</p>

              <p className="section5922abcx22">Please delete the rest by pressing ⌫.</p>

              <ul>
                {parentphonenumber && parentphonenumber.map((info, i) => (
                  <>
                    {info != "" ? <li key={i} className="list" >{info} <div className="section5922aaa" onClick={() => readonly()}>⌫
                    </div>
                    </li> : null}


                    {typeof parentphonenumber != "undefined" && parentphonenumber.length == 0 ? <li className="list"><div className="section5922aaa">Unsubscribed from Texts
                    </div></li> : null}


                  </>
                ))}


                {parentemail && parentemail.map((info, i) => (
                  <>
                    {info != "" ?
                      <li key={i} className="list" >{info} <div className="section5922aaa" onClick={() => readonly()}>⌫
                      </div>
                      </li> : null}

                    {typeof parentemail != "undefined" && parentemail.length == 0 ? <li className="list"><div className="section5922aaa">Unsubscribed from Emails
                    </div></li> : null}


                  </>
                ))}
              </ul>
              <p className="section5922ax35" onClick={() => setBringinmenu2(!bringinmenu2)}>Add any additional phone number or email address if it is there where you would also like to receive messages.</p>

            </div>


          </div>
          <div className="field2">
            <input
              placeholder="New Email/Phone #"
              placeholdertextcolor="#BEBEBE"
              value={newnumber3} // ...force the input's value to match the state variable...
              onChange={e => onChanged1(e.target.value)}
              type="text"
            />
          </div>

          <div className="section598">

            {typeof newnumber3 != "undefined" && newnumber3.length === 10 ? <p className="section5922ax" onClick={() => readonly()}>Submit this Phone Number</p> : typeof newnumber3 != "undefined" && newnumber3.includes("@") ? <p className="section5922ax" onClick={() => readonly()}>Submit this new Email</p> : <p className="section5922ax">          </p>}

          </div>
        </header> : language == "en" ? <header className="App-header">

          <div className="container22a">


            <div className="section591">

              <p className="section5922ab" onClick={() => setBringinmenu2(!bringinmenu2)} ofclassavailable>Messaging From <br />{student}'s {classs} Class</p>

              <br />   <br />

              <p className="section5922ax" onClick={() => setBringinmenu2(!bringinmenu2)} ofclassavailable>The emails and phone numbers that {teacher} has to message you are listed below. Please leave only the numbers or email addresses if it is there where you would like to receive messages.</p>

              <p className="section5922abcx22">Please delete the rest by pressing ⌫.</p>

              <ul>
                {typeof parentphonenumber != "undefined" && parentphonenumber.map((info, i) => (
                  <>
                    {parentphonenumber.length > 0 ?
                      <li key={i} className="list" >{info} <div className="section5922aaa" onClick={() => deletethisnumber(info)}>⌫
                      </div>
                      </li> : null}
                  </>
                ))}

                {typeof parentphonenumber != "undefined" && parentphonenumber.length == 0 ? <li className="list"><div className="section5922aaa">Unsubscribed from Texts
                </div></li> : null}


                {typeof parentemail != "undefined" && parentemail.map((info, i) => (
                  <>
                    {parentemail.length > 0 ? <li key={i} className="list" >{info} <div className="section5922aaa" onClick={() => deletethisemail(info)}>⌫
                    </div>
                    </li> : null}
                  </>
                ))}

                {typeof parentemail != "undefined" && parentemail.length == 0 ? <li className="list"><div className="section5922aaa">Unsubscribed from Emails
                </div></li> : null}

              </ul>



              <p className="section5922ax35" onClick={() => setBringinmenu2(!bringinmenu2)}>Add any additional phone number or email address if it is there where you would also like to receive messages.</p>

            </div>


          </div>
          <div className="field2">
            <input
              placeholder="New Email/Phone #"
              placeholdertextcolor="#BEBEBE"
              value={newnumber3} // ...force the input's value to match the state variable...
              onChange={e => onChanged1(e.target.value)}
              type="text"
            />
          </div>

          <div className="section598">

            {typeof newnumber3 != "undefined" && newnumber3.length === 10 ? <p className="section5922ax" onClick={() => addthisnumber()}>Submit this Phone Number</p> : typeof newnumber3 != "undefined" && newnumber3.includes("@") ? <p className="section5922ax" onClick={() => addthisnumber2()}>Submit this new Email</p> : <p className="section5922ax">          </p>}

          </div>
        </header> : <header className="App-header">

          <div className="container22a">


            <div className="section591">

              <p className="section5922ab" onClick={() => setBringinmenu2(!bringinmenu2)} ofclassavailable>{text0} <br />{student}'s {classs} {text1}</p>

              <br />   <br />

              <p className="section5922ax" onClick={() => setBringinmenu2(!bringinmenu2)} ofclassavailable>{text2} {teacher} {text3}</p>

              <p className="section5922abcx22">{text4} ⌫.</p>

              <ul>
                {parentphonenumber && parentphonenumber.map((info, i) => (
                  <>
                    {info != "" ? <li key={i} className="list" >{info} <div className="section5922aaa" onClick={() => deletethisnumber(info)}>⌫
                    </div>
                    </li> : null}
                  </>
                ))}

                {typeof parentphonenumber != "undefined" && parentphonenumber.length == 0 ? <li className="list"><div className="section5922aaa">{text9}
                </div></li> : null}



                {parentemail && parentemail.map((info, i) => (
                  <>
                    {info != "" ? <li key={i} className="list" >{info} <div className="section5922aaa" onClick={() => deletethisemail(info)}>⌫
                    </div>
                    </li> : null}
                  </>
                ))}


                {typeof parentemail != "undefined" && parentemail.length == 0 ? <li className="list"><div className="section5922aaa">{text10}
                </div></li> : null}
              </ul>
              <p className="section5922ax35" onClick={() => setBringinmenu2(!bringinmenu2)}>{text5}</p>

            </div>


          </div>
          <div className="field2">
            <input
              placeholder={text8}
              placeholdertextcolor="#BEBEBE"
              value={newnumber3} // ...force the input's value to match the state variable...
              onChange={e => onChanged1(e.target.value)}
              type="text"
            />
          </div>

          <div className="section598">

            {typeof newnumber3 != "undefined" && newnumber3.length === 10 ? <p className="section5922ax" onClick={() => addthisnumber()}>{text6}</p> : typeof newnumber3 != "undefined" && newnumber3.includes("@") ? <p className="section5922ax" onClick={() => addthisnumber2()}>{text7}</p> : <p className="section5922ax">          </p>}

          </div>
        </header>}
      </div>
    </div>
  );
}

export default App;